/* Navigation measurement v1. Shopify owns consent; the existing Google tag owns transport.
 * No storage, delayed navigation, additional pageviews, or ecommerce events.
 */
window.Blundstone = window.Blundstone || {};
(() => {
  if (window.Blundstone.navAnalytics || (window.Shopify && window.Shopify.designMode)) return;
  window.Blundstone.navAnalytics = true;
  const panelSelector = '[data-nav-panel]';
  const states = new Map();
  const dwell = 500;
  let lastInput = 'pointer';
  let consent = allowed();

  function allowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
  }
  function context(element) {
    const header = element.closest('[data-nav-analytics]');
    if (!header) return null;
    const surface = element.closest('[data-nav-surface]');
    const panel = element.closest('[data-nav-panel-id]');
    return {
      nav_version: header.dataset.navVersion,
      nav_market: header.dataset.navMarket,
      nav_locale: header.dataset.navLocale,
      nav_surface: surface ? surface.dataset.navSurface : 'header',
      nav_variant: surface ? surface.dataset.navVariant : 'header',
      nav_panel: panel ? panel.dataset.navPanelId : 'header'
    };
  }
  function send(name, element, params) {
    if (!allowed() || document.visibilityState === 'hidden') return false;
    const values = context(element);
    if (!values) return false;
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('event', name, Object.assign(values, params, { send_to: 'G-ETNNY3YE8S' }));
    return true;
  }
  function visible(panel) {
    if (!panel.isConnected || !panel.getClientRects().length || document.visibilityState === 'hidden') return false;
    if (panel.tagName === 'DETAILS') return panel.open;
    const drawer = panel.closest('blundstone-menu-drawer');
    return panel.classList.contains('is-open') && !!(drawer && drawer.querySelector('details[open]'));
  }
  function emitOpen(panel, state, reason) {
    if (state.sent || !visible(panel)) return;
    const info = context(panel);
    if (info) state.sent = send('nav_open', panel, {
      nav_id: info.nav_panel,
      nav_trigger: state.trigger,
      nav_open_reason: reason
    });
  }
  function scan() {
    const nowAllowed = allowed();
    if (!nowAllowed || nowAllowed !== consent) {
      states.forEach(state => clearTimeout(state.timer));
      states.clear();
    }
    consent = nowAllowed;
    if (!consent) return;
    // Switching tabs pauses dwell; it must not create another opening on return.
    if (document.visibilityState === 'hidden') {
      states.forEach(state => { clearTimeout(state.timer); state.timer = null; });
      return;
    }
    states.forEach((state, panel) => {
      if (!visible(panel)) {
        clearTimeout(state.timer);
        states.delete(panel);
      }
    });
    document.querySelectorAll('[data-nav-analytics] [data-nav-panel]').forEach(panel => {
      if (!visible(panel)) return;
      const existing = states.get(panel);
      if (existing) {
        if (!existing.sent && !existing.timer) {
          existing.opened = Date.now();
          existing.timer = setTimeout(() => emitOpen(panel, existing, 'dwell'), dwell);
        }
        return;
      }
      const state = { opened: Date.now(), sent: false, trigger: lastInput };
      states.set(panel, state);
      state.timer = setTimeout(() => emitOpen(panel, state, 'dwell'), dwell);
    });
  }
  function destination(anchor) {
    // Only store a static navigation path. Never send query strings, fragments or link text.
    try {
      const url = new URL(anchor.getAttribute('href'), window.location.origin);
      if (!/^https?:$/.test(url.protocol)) return null;
      const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
      if (!/^\/(?:collections|products|pages|blogs|policies)(?:\/|$)/.test(path) && path !== '/') return null;
      return { nav_id: path === '/' ? 'home' : path.slice(1).replace(/\//g, ':'), nav_destination: path };
    } catch (_) { return null; }
  }
  function activate(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (event.type === 'click' && event.button > 0) return;
    const target = event.target.closest && event.target.closest('[data-nav-link], [data-header-action]');
    if (!target || !target.closest('[data-nav-analytics]') || !allowed()) return;
    lastInput = event.detail === 0 ? 'keyboard' : 'click';
    if (target.hasAttribute('data-header-action')) {
      // A second click closing a search/localization panel isn't another open action.
      if (target.tagName === 'SUMMARY' && target.parentElement.open) return;
      if (target.getAttribute('aria-expanded') === 'true') return;
      send('header_action', target, { nav_id: target.dataset.headerAction, nav_type: 'header_icon', nav_trigger: lastInput });
      return;
    }
    const route = destination(target);
    if (!route) return;
    scan();
    const panel = target.closest(panelSelector);
    const state = states.get(panel);
    if (state) emitOpen(panel, state, 'click');
    const params = Object.assign(route, {
      nav_type: target.dataset.navType,
      nav_level: target.dataset.navLevel,
      nav_position: target.dataset.navPosition,
      nav_trigger: lastInput
    });
    if (state) params.nav_dwell_ms = Math.max(0, Date.now() - state.opened);
    send('nav_click', target, params);
  }
  document.addEventListener('pointerover', () => { lastInput = 'hover'; }, true);
  document.addEventListener('pointerdown', () => { lastInput = 'click'; }, true);
  document.addEventListener('keydown', () => { lastInput = 'keyboard'; }, true);
  document.addEventListener('click', activate, true);
  document.addEventListener('auxclick', activate, true);
  document.addEventListener('visitorConsentCollected', scan);
  document.addEventListener('visibilitychange', scan);
  window.addEventListener('resize', scan);
  window.addEventListener('pageshow', scan);
  document.addEventListener('shopify:section:load', init);
  function init() {
    document.querySelectorAll('[data-nav-analytics]').forEach(header => {
      if (header.dataset.navObserved) return;
      header.dataset.navObserved = 'true';
      new MutationObserver(scan).observe(header, {
        subtree: true, attributes: true, attributeFilter: ['open', 'class'], childList: true
      });
    });
    scan();
  }
  init();
})();
